import style from './photo.module.css'
import close from '../../img/close.svg'

function Photo({activePhoto,setActivePhoto}){

    return (
      (activePhoto != null ? 
            <div className={style.blackph}>
                <div className={style.contentph}>
                    <img src={activePhoto} alt=""/>
                    <div className={style.closebtn}>
                        <img src={close} alt="" onClick={ (() => {setActivePhoto(null);})}/>
                    </div>
                </div>
            </div>
        :
        null
      )
    );
}
export default Photo;